import { apiGet } from 'utils/http';

const configAPI = {
  getConfig: async () => {
    return apiGet(`/config`);
  },
};

export { configAPI };
